import { GB_VAT_AMOUNT, IE_VAT_AMOUNT } from '@npi/buddy-utils';
import { CountryCode } from 'libphonenumber-js';
export interface TaxRule {
    name: string;
    rate: number; // e.g., 0.23 for 23%
    includedInPrice: boolean;
}
export interface CountryConfig {
    name: string;
    defaultCurrency: string;
    supportedCurrencies: string[];
    postalCodeType: 'POSTCODE' | 'EIRCODE' | 'ZIPCODE' | 'PIN' | 'POSTALCODE';
    phoneCode: string;
}

// #region Helpers
export const isIreland = ((process.env.REGION as CountryCode) ?? 'IE') === 'IE';

export const getVatAmount = () => {
    if (isIreland) {
        return IE_VAT_AMOUNT;
    }
    return GB_VAT_AMOUNT;
};

// #endregion Helpers
